import { EventKey } from "PFTypes/event_key";

export const calculateKeyboardScrollableContainerDimensions = (
  e: React.KeyboardEvent<HTMLDivElement>,
  scrollableContainer: HTMLDivElement | null,
  step: number = 40
) => {
  if (!scrollableContainer) {
    return { scrollLeft: 0 };
  }
  const container = scrollableContainer;
  const largeStep = container.clientWidth;
  const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
  let newScrollLeft = container.scrollLeft;

  switch (e.key) {
    case EventKey.ArrowLeft:
      e.preventDefault();
      newScrollLeft = Math.max(0, container.scrollLeft - step);
      break;
    case EventKey.ArrowRight:
      e.preventDefault();
      newScrollLeft = Math.min(maxScrollLeft, container.scrollLeft + step);
      break;
    case EventKey.Home:
      e.preventDefault();
      newScrollLeft = 0;
      break;
    case EventKey.End:
      e.preventDefault();
      newScrollLeft = maxScrollLeft;
      break;
    case EventKey.PageUp:
      e.preventDefault();
      newScrollLeft = Math.max(0, container.scrollLeft - largeStep);
      break;
    case EventKey.PageDown:
      e.preventDefault();
      newScrollLeft = Math.min(maxScrollLeft, container.scrollLeft + largeStep);
      break;
    default:
      return { scrollLeft: 0 };
  }

  return { scrollLeft: newScrollLeft };
};
